import Vue from 'vue';
import dictionaryService from './dictionary.service';

function translateFilter(value: string, ...args: string[]) {
    return value ? dictionaryService.get(value, args) : '';
}

Vue.filter('t', translateFilter);

export default translateFilter;
